"use strict";

module.exports = {
  TYPE_EXTERNAL: "external",
  TYPE_ACT_AS: "actAs"
};
